import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import styles from './styles.module.css';

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } },
};

const stepIcons = [
  <svg key="1" width="40" height="40" viewBox="0 0 48 48" fill="none" stroke="#5BA4CF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="24" cy="24" r="16" fill="rgba(91,164,207,.08)" />
    <circle cx="24" cy="24" r="7" />
    <circle cx="24" cy="24" r="2.5" fill="#5BA4CF" stroke="none" />
  </svg>,
  <svg key="2" width="40" height="40" viewBox="0 0 48 48" fill="none" stroke="#5BA4CF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="8" y="10" width="32" height="28" rx="4" fill="rgba(91,164,207,.08)" />
    <path d="M24 30V18M17 25l7-7 7 7" />
  </svg>,
  <svg key="3" width="40" height="40" viewBox="0 0 48 48" fill="none" stroke="#5BA4CF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="10" y="8" width="28" height="32" rx="4" fill="rgba(91,164,207,.08)" />
    <path d="M18 18h12M18 24h12M18 30h8" />
    <circle cx="36" cy="36" r="6" fill="#0B1F3A" stroke="#5BA4CF" />
    <path d="M33 36l2 2 4-4" stroke="#5BA4CF" strokeWidth="1.5" strokeLinecap="round" />
  </svg>,
];

export default function ComoFunciona() {
  const { t } = useTranslation('landing');

  const steps = t('comoFunciona.steps', { returnObjects: true });

  return (
    <motion.section
      id="how"
      className={styles.section}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
      variants={fadeUp}
    >
      <div className={styles.container}>
        <div className={styles.center}>
          <span className={styles.tag}>{t('comoFunciona.tag')}</span>
          <h2 className={styles.title}>{t('comoFunciona.title')}</h2>
          <p className={styles.subtitle}>{t('comoFunciona.subtitle')}</p>
        </div>
        <div className={styles.steps}>
          {steps.map((step, i) => (
            <div key={i} className={styles.step}>
              <div className={styles.stepIco}>
                {stepIcons[i]}
                <div className={styles.stepNum}>{i + 1}</div>
              </div>
              <h3 className={styles.stepTitle}>{step.title}</h3>
              <p className={styles.stepDesc}>{step.desc}</p>
              <span className={styles.stepTag}>{step.tag}</span>
            </div>
          ))}
        </div>
        <div className={styles.note}>
          {t('comoFunciona.note.prefix')}{' '}
          <strong>{t('comoFunciona.note.bold')}</strong>{' '}
          {t('comoFunciona.note.suffix')}
        </div>
      </div>
    </motion.section>
  );
}
